module.exports = __webpack_public_path__ + "img/third-logo.b017968e.png";